import { useState, useRef } from 'react';
import ReactDOM from 'react-dom';

// Hover tooltip, portalled to document.body so it is never clipped by a
// scrolling panel or a drawer's overflow. Extracted from Dashboard.js so
// components Dashboard imports can use it too -- importing it back out of
// Dashboard would be a circular import.
export default function TKTooltip({ text, children, align='right' }) {
  const [show, setShow] = useState(false);
  const [rect, setRect] = useState(null);
  const ref = useRef(null);
  const handleEnter = () => {
    if (ref.current) setRect(ref.current.getBoundingClientRect());
    setShow(true);
  };
  const handleLeave = () => setShow(false);

  let tooltipStyle = {};
  if (rect) {
    const GAP = 8;
    // Anchor by the edge nearest the trigger so the box grows AWAY from it.
    // Previously this set `top: rect.top - 44`, which only cleared the trigger
    // for tooltips short enough to fit in 44px -- a longer one grew downwards
    // and covered the control it was describing.
    const room = rect.top;
    const vertical = room > 130
      ? { bottom: Math.max(4, window.innerHeight - rect.top + GAP), top: 'auto' }
      : { top: rect.bottom + GAP, bottom: 'auto' };

    if (align === 'left') {
      tooltipStyle = { right: Math.max(4, window.innerWidth - rect.right), left: 'auto', transform: 'none', ...vertical };
    } else if (align === 'center') {
      tooltipStyle = { left: Math.max(4, Math.min(rect.left + rect.width / 2 - 115, window.innerWidth - 234)), ...vertical };
    } else {
      tooltipStyle = { left: Math.max(4, Math.min(rect.left, window.innerWidth - 234)), ...vertical };
    }
  }

  return (
    <span ref={ref} style={{position:'relative',display:'inline-flex',alignItems:'center',gap:'3px'}}
      onMouseEnter={handleEnter} onMouseLeave={handleLeave}>
      {children}
      {show && rect && ReactDOM.createPortal(
        <div style={{
          position:'fixed',...tooltipStyle,
          zIndex:99999,background:'#28395C',border:'1px solid #3A4F7D',borderRadius:'6px',
          padding:'7px 10px',width:'230px',fontSize:'12px',color:'#e2e8f0',
          lineHeight:'1.5',boxShadow:'0 4px 16px rgba(0,0,0,0.4)',pointerEvents:'none',whiteSpace:'normal'
        }}>
          {text}
        </div>,
        document.body
      )}
    </span>
  );
}
